import React from "react";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../../../componentLibrary/Button";
import { LessonI } from "../../../types";

interface LessonPreviewProps {
  lesson: LessonI;
  onDeleteClick: (type: "lesson", id: string, title: string) => void;
}

const LessonPreview: React.FC<LessonPreviewProps> = ({
  lesson,
  onDeleteClick,
}) => {
  return (
    <div className="h-full flex flex-col">
      {/* Sticky header with delete button */}
      <div className="flex items-center justify-between pb-4 border-b flex-shrink-0">
        <div className="flex items-center gap-4">
          {lesson.icon?.src && (
            <img
              src={lesson.icon.src}
              alt={lesson.icon.alt || lesson.title}
              className="w-12 h-12 object-contain"
            />
          )}
          <div>
            <h3 className="text-xl font-semibold">{lesson.title}</h3>
            <p className="text-sm text-gray-500">
              {lesson.pages?.length || 0} pages
            </p>
          </div>
        </div>
        <Button
          variant="cautionary"
          onClick={() => onDeleteClick("lesson", lesson._id, lesson.title)}
          className="flex items-center gap-2 flex-shrink-0"
        >
          <TrashIcon className="w-5 h-5" />
          Delete Lesson
        </Button>
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto mt-4">
        <div className="space-y-4">
          <h4 className="font-medium text-gray-700">Pages in this lesson:</h4>
          {lesson.pages && lesson.pages.length > 0 ? (
            <div className="space-y-3">
              {lesson.pages.map((page, index) => (
                <div
                  key={page._id}
                  className="p-4 bg-gray-50 rounded-lg border"
                >
                  <p className="font-medium">
                    Page {index + 1}: {page.title || "Untitled Page"}
                  </p>
                  <p className="text-sm text-gray-500">
                    {page.components?.length || 0} components
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 italic">No pages in this lesson</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LessonPreview;
